export { default as StyledSvg } from './StyledSvg';

//Icons used in buttons
export { Close } from './Close';
export { RightArrow } from './Arrow';
export { ArrowLeft } from './ArrowLeft';
export { ArrowRight } from './ArrowRight';
export { ArrowDown } from './ArrowDown';
export { ArrowSmall } from './ArrowSmall';
export { Download } from './Download';
export { Email } from './Email';
export { Error } from './Error';
export { ExternalLink } from './ExternalLink';
export { Filter } from './Filter';
export { Hamburger } from './Hamburger';
export { Language } from './Language';
export { Magnifier } from './Magnifier';
export { Phone } from './Phone';
export { Profile } from './Profile';
export { ScheduleUpdate } from './ScheduleUpdate';
export { Share } from './Share';
export { Insights } from './Insights';
export { Star } from './Star';
export { Trash } from './Trash';
export { Location } from './Location';
export { Success } from './Success';

//Social Media Icons
export { Facebook } from './Facebook';
export { Instagram } from './Instagram';
export { LinkedIn } from './LinkedIn';
export { TikTok } from './TikTok';
export { Twitter } from './Twitter';
export { YouTube } from './YouTube';
export { FacebookColor } from './FacebookColor';
export { GoogleColor } from './GoogleColor';
export { WhatsApp } from './WhatsApp';
export { EVInsider } from './EV-Insider';

//Media Gallery Icons
export { FloorPlan } from './FloorPlan';
export { StreetView } from './StreetView';
export { VirtualTour } from './VirtualTour';
export { Video } from './Video';
export { Grid } from './Grid';

//Listing Details Icons
export { Bath } from './Bath';
export { Bed } from './Bed';
export { PropertyType } from './PropertyType';
export { SqFoot } from './SqFoot';
export { MLS } from './MLS';

//Other Svgs
export { ChevronLeft, ChevronRight, ChevronDown, ChevronUp } from './Chevrons';
export { Status } from './Status';
